import React from 'react';

export default (_props) => {
  const { className, size, large, small, ...props } = _props;

  // small icon
  if ((size && size.toLowerCase() === 'small') || small) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" className={`audiicon audiicon-small ${className ? className : ''}`} {...props}>
        <path d="M11.5,1.5 C15.4,1.5 18.5,4.6 18.5,8.5 C18.5,12.4 11.5,22.5 11.5,22.5 C11.5,22.5 4.5,12.4 4.5,8.5 C4.5,4.6 7.6,1.5 11.5,1.5 Z M11.5,5.5 C9.84314575,5.5 8.5,6.84314575 8.5,8.5 C8.5,10.1568542 9.84314575,11.5 11.5,11.5 C13.1568542,11.5 14.5,10.1568542 14.5,8.5 C14.5,6.84314575 13.1568542,5.5 11.5,5.5 Z" fill="currentColor" fillRule="nonzero" stroke="none" strokeWidth="1"/>
      </svg>
    );
  }

  // large icon
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" className={`audiicon audiicon-large ${className ? className : ''}`} {...props}>
      <path d="M23.5,3.5 C31.2,3.5 37.5,9.8 37.5,17.5 C37.5,25.2 23.5,44.5 23.5,44.5 C23.5,44.5 9.5,25.2 9.5,17.5 C9.5,9.8 15.8,3.5 23.5,3.5 Z M23.5,10.5 C19.6340068,10.5 16.5,13.6340068 16.5,17.5 C16.5,21.3659932 19.6340068,24.5 23.5,24.5 C27.3659932,24.5 30.5,21.3659932 30.5,17.5 C30.5,13.6340068 27.3659932,10.5 23.5,10.5 Z" fill="currentColor" fillRule="nonzero" stroke="none" strokeWidth="1"/>
    </svg>
  );
};
